"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getEnabledAppsRequest = void 0;

var _environment = require("../../environment");

var getEnabledAppsRequest = function getEnabledAppsRequest() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;

  if (process.env.APP_SUITE_USE_MYACCOUNT === 'true') {
    var url = (0, _environment.getUrlForApp)(location, _environment.AppKeys.account, true);
    url.pathname = '/api/features/getEnabledApps';
    return {
      url: url.toString(),
      audience: process.env.APP_ADAL_MYACCOUNT_CLIENT_ID
    };
  } else {
    return {
      url: (0, _environment.getApiServerUrl)('/api/features/getEnabledApps')
    };
  }
};

exports.getEnabledAppsRequest = getEnabledAppsRequest;